/**
 * Creates a new Map Label
 * @constructor
 * @extends google.maps.OverlayView
 * @param {Object.<string, *>=} opt_options Optional properties to set.
 */

export default function MapLabelService(vm, google, map, opt_options) {

  MapLabel.prototype = new google.maps.OverlayView;

  function MapLabel(vm, map, opt_options) {
    this._vm = vm;
    this.map = map;

    this.fontFamily = 'sans-serif';
    this.fontSize = opt_options.fontSize || 14;
    this.fontColor = opt_options.fontColor || '#000000';
    this.strokeWeight = opt_options.strokeWeight || 2;
    this.strokeColor = '#ffffff';
    this.align = opt_options.align || 'center';
    this.zIndex = opt_options.zIndex || 1e3;
    this.position = opt_options.position
    this.text = opt_options.text

    this.setMap(map)
    this.draw()
    // this.drawCanvas_()
  }

  /** @inheritDoc */
  MapLabel.prototype.changed = function (prop) {
    switch (prop) {
      case 'fontFamily':
      case 'fontSize':
      case 'fontColor':
      case 'strokeWeight':
      case 'strokeColor':
      case 'align':
      case 'text':
        return this.drawCanvas_();
      case 'maxZoom':
      case 'minZoom':
      case 'position':
        return this.draw();
    }
  };

  /**
   * Draws the label to the canvas 2d context.
   * @private
   */
  MapLabel.prototype.drawCanvas_ = function () {
    var canvas = this.canvas_;
    if (!canvas) return;

    var style = canvas.style;
    style.zIndex = /** @type number */(this.zIndex);

    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = this.strokeColor;
    ctx.fillStyle = this.fontColor;
    ctx.font = this.fontSize + 'px ' + this.fontFamily;

    var strokeWeight = Number(this.strokeWeight);

    var text = this.text;
    if (text) {
      if (strokeWeight) {
        ctx.lineWidth = strokeWeight;
        ctx.strokeText(text, strokeWeight, strokeWeight);
      }

      ctx.fillText(text, strokeWeight, strokeWeight);

      var textMeasure = ctx.measureText(text);
      var textWidth = textMeasure.width + strokeWeight;
      style.marginLeft = this.getMarginLeft_(textWidth) + 'px';
      // Bring actual text top in line with desired latitude.
      // Cheaper than calculating height of text.
      style.marginTop = '-0.4em';
    }
  };

  /**
   * @inheritDoc
   */
  MapLabel.prototype.onAdd = function () {
    var canvas = this.canvas_ = document.createElement('canvas');
    var style = canvas.style;
    style.position = 'absolute';

    var ctx = canvas.getContext('2d');
    ctx.lineJoin = 'round';
    ctx.textBaseline = 'top';

    this.drawCanvas_();

    var panes = this.getPanes();

    if (panes) {
      panes.floatPane.appendChild(canvas);
    }
  };

  /**
   * Gets the appropriate margin-left for the canvas.
   * @private
   * @param {number} textWidth  the width of the text, in pixels.
   * @return {number} the margin-left, in pixels.
   */
  MapLabel.prototype.getMarginLeft_ = function (textWidth) {
    switch (this.align) {
      case 'left':
        return 0;
      case 'right':
        return -textWidth;
    }
    return textWidth / -2;
  };

  /**
   * @inheritDoc
   */
  MapLabel.prototype.draw = function () {
    var projection = this.getProjection();

    if (!projection) {
      // The map projection is not ready yet so do nothing
      return;
    }

    if (!this.canvas_) {
      // onAdd has not been called yet.
      return;
    }

    var latLng = /** @type {google.maps.LatLng} */ this.position;
    if (!latLng) {
      return;
    }
    var pos = projection.fromLatLngToDivPixel(latLng);

    var style = this.canvas_.style;

    style['top'] = pos.y + 'px';
    style['left'] = pos.x + 'px';

    style['visibility'] = this.getVisible_();
  };

  /**
   * Get the visibility of the label.
   * @private
   * @return {string} blank string if visible, 'hidden' if invisible.
   */
  MapLabel.prototype.getVisible_ = function () {
    var minZoom = /** @type number */(this.minZoom);
    var maxZoom = /** @type number */(this.maxZoom);

    if (minZoom === undefined && maxZoom === undefined) {
      return '';
    }

    var map = this.getMap();
    if (!map) {
      return '';
    }

    var mapZoom = map.getZoom();
    if (mapZoom < minZoom || mapZoom > maxZoom) {
      return 'hidden';
    }
    return '';
  };

  /**
   * @inheritDoc
   */
  MapLabel.prototype.onRemove = function () {
    var canvas = this.canvas_;
    if (canvas && canvas.parentNode) {
      canvas.parentNode.removeChild(canvas);
    }
  };

  return new MapLabel(vm, map, opt_options)
}
